<div class="">
  <div class="rightside ">
    <div class="righthead">
      <div class="heading border-bottom">
        <h2>{{helpCenters?.helpCenterCategories?.title}}</h2> 
      </div>
    </div>
    <div class="rightbody m-3">
      <h4>{{helpCenters?.title}}</h4>
      <div class="linkpara p-3" [innerHTML]="helpCenters?.description">
      </div>
    </div> 
  </div> 
</div>